import {
  Audience,
  AudienceNetwork,
  AudiencePerson,
  AudiencePublication,
  AudienceRef,
} from './types';

export const peopleLabel = (count: number): string =>
  `${count} personne${count > 1 ? 's' : ''}`;

/** Effectif d'un ou plusieurs groupes : la somme de leurs effectifs */
export const countLabel = (audiences: Audience[]): string =>
  peopleLabel(
    audiences.reduce((sum, audience) => sum + audience.member_count, 0),
  );

/** Type d'une publication ciblée (message ou sondage) */
export const typeLabel = (
  modelType: AudiencePublication['model_type'],
): string => (modelType === 'poll' ? 'Sondage' : 'Message');

/** Taux de lecture d'une publication ciblée : lecteurs distincts sur la portée */
export const readRate = (viewers: number, reach: number): string =>
  reach > 0 ? `${Math.round((viewers / reach) * 100)} %` : '—';

/**
 * Entrée « Groupes » : gestionnaire qui peut publier, avec au moins un Réseau qui a des
 * groupes actifs (GET /me/audiences non vide)
 */
export const canTargetAudiences = (
  canView: boolean,
  canPublish: boolean,
  networks: AudienceNetwork[],
): boolean => canView && canPublish && networks.length > 0;

/** Badge d'une publication ciblée dans les listes */
export const audienceTagLabel = (audiences: AudienceRef[]): string =>
  `Ciblée · ${audiences.map(audience => audience.label).join(', ')}`;

/** « Prénom Nom » d'une personne des listes d'un groupe */
export const personName = (person: AudiencePerson): string =>
  `${person.firstname ?? ''} ${person.lastname ?? ''}`.trim();
